export default function schoolTypes(state = [], action) {
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/schoolTypes.js